module.exports = __webpack_public_path__ + "assets/img/img_2015.c7d0cb4e.jpg";